<!--
 * @Author: Sephiroth·D·Kid
 * @Date: 2019-07-02 15:52:30
 * @LastEditors: yuka
 * @LastEditTime: 2019-08-09 16:20:37
 * @Description: Tab
 -->
<template>
  <div class="m-mid-tab-wrapper">
    <div class="tab-content-box">
      <swiper :options="swiperOption3" ref="mySwiper">
        <swiper-slide class="tab-content">
          <img src="https://files.jinr.com/jinr-index/img/mid-tab-01.png" alt="" srcset="" />
          <div class="text">
            <h3>大数据风控</h3>
            <div class="line"></div>
            <p>
              鲸鱼接入了丰富的数据源，构造多种变量，并建立了基于深度学习的风控模型，实现了高效、准确的信贷风险评估
            </p>
          </div>
        </swiper-slide>
        <swiper-slide class="tab-content">
          <img src="https://files.jinr.com/jinr-index/img/mid-tab-02.png" alt="" srcset="" />
          <div class="text">
            <h3>小额分散</h3>
            <div class="line"></div>
            <p>
              小额分散的投资方式有效的分散了投资风险，保护投资者的权益，全方位为社会所有阶层和群体提供普惠金融服务
            </p>
          </div>
        </swiper-slide>
        <swiper-slide class="tab-content">
          <img src="https://files.jinr.com/jinr-index/img/mid-tab-03.png" alt="" srcset="" />
          <div class="text">
            <h3>资产多元化</h3>
            <div class="line"></div>
            <p>鲸鱼致力于接入信用评级高的消费信贷、车辆抵押贷款，多种资产方式防止系统性风险</p>
          </div>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
  </div>
</template>
<script>
import 'swiper/dist/css/swiper.css';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
export default {
  name: 'mid-tab',
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      swiperOption3: {
        // some swiper options/callbacks
        // 所有的参数同 swiper 官方 api 参数
        // ...
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets'
        }
        // loopedSlides: 5,
      }
    };
  }
};
</script>
<style lang="less">
.m-mid-tab-wrapper {
  height: 3.44rem;
  .tab-content-box {
    width: 100%;
    height: 100%;
  }
  .tab-content {
    overflow: hidden;
  }
  .swiper-container {
    height: 100%;
  }
  img {
    height: 100%;
    margin-left: -3.3rem;
    // top: 0;
    // position: absolute;
    // left: 50%;
  }
  .text {
    width: 3.4rem;
    position: absolute;
    left: 0.4rem;
    top: 0.68rem;
    z-index: 2;
    text-align: left;
    letter-spacing: 0rem;
    h3 {
      font-family: 'PingFangSC-Medium';
      font-size: 0.24rem;
      color: #dde4f5;
    }
    .line {
      width: 0.47rem;
      height: 0.02rem;
      background: #d8d8d8;
      margin: 0.1rem 0 0.4rem;
    }
    p {
      font-family: 'PingFangSC-Regular';
      font-size: 0.2rem;
      color: #bbc5dc;
    }
  }
  .swiper-pagination-bullet {
    width: 0.12rem;
    height: 0.12rem;
    transform: none;
    background-color: #d8d8d8;
    opacity: 1;
  }
  .swiper-pagination-bullet-active {
    background-color: #0d74e3;
  }
  .swiper-container-horizontal {
    .swiper-pagination-bullets {
      transform: none;
      bottom: 0.22rem;
      line-height: 1;
    }
  }
}
</style>
